import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin } from 'lucide-react';
const testimonials = [{
  initials: 'CG',
  name: 'Camila G.',
  location: 'Ciudad de México, México',
  role: 'Docente de Química',
  quote: '“Compré el MEGAPACK un domingo por la noche. El lunes tenía todo el año de Química organizado. Nunca pensé que un material iba a ser tan completo. Las rúbricas por actividad son exactamente lo que necesitaba: no tengo que pensar los criterios de cero para cada evaluación."',
  color: 'bg-blue-600'
}, {
  initials: 'MG',
  name: 'Martín G.',
  location: 'Medellín, Colombia',
  role: 'Docente de Química',
  quote: '“Las actividades secuenciadas me cambiaron la forma de planificar y por fin sentí que tenía una estructura real para todo el año."',
  color: 'bg-indigo-600'
}, {
  initials: 'LG',
  name: 'Laura G.',
  location: 'Montevideo, Uruguay',
  role: 'Educación secundaria',
  quote: '“Lo que más valoro es que está organizado por nivel. No tengo que adivinar qué le corresponde a cada curso. Todo ya está pensado, ordenado y listo."',
  color: 'bg-sky-600'
}, {
  initials: 'AT',
  name: 'Alejandra T.',
  location: 'Quito, Ecuador',
  role: 'Docente de Química',
  quote: '“Llegué al inicio de clases con todo listo por primera vez en años. Las guías de laboratorio con fichas de registro me salvaron para la muestra anual."',
  color: 'bg-teal-600'
}, {
  initials: 'RS',
  name: 'Roberto S.',
  location: 'Santiago, Chile',
  role: 'Educación secundaria',
  quote: '“Las rúbricas integradas me cambiaron la corrección. Por fin evalúo con criterios claros y mis estudiantes saben qué se espera en cada actividad."',
  color: 'bg-slate-600'
}];
export function DetailedTestimonials() {
  return <section className="py-6 md:py-12 px-4 bg-sky-50" data-id="element-43">
      <div className="max-w-6xl mx-auto" data-id="element-44">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-slate-900 mb-6 md:mb-10" data-id="element-45">
          Lo que dicen los docentes
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-46">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-[2rem] shadow-xl shadow-blue-900/5 border border-blue-100 flex flex-col" data-id="element-47">
              <div className="flex gap-1 mb-4" data-id="element-48">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-49" />)}
              </div>
              <blockquote className="text-slate-800 font-bold text-sm md:text-lg leading-relaxed mb-8 flex-1 italic" data-id="element-50">
                {t.quote}
              </blockquote>
              <div className="flex items-center gap-4 pt-6 border-t border-slate-50" data-id="element-51">
                <div className={`${t.color} w-12 h-12 rounded-2xl flex items-center justify-center text-white font-black text-lg shadow-lg shrink-0`} data-id="element-52">
                  {t.initials}
                </div>
                <div data-id="element-53">
                  <p className="font-black text-slate-900 text-sm md:text-base" data-id="element-54">
                    {t.name}
                  </p>
                  <div className="flex items-center gap-1 text-slate-500 font-medium text-[10px] md:text-xs" data-id="element-55">
                    <MapPin size={12} data-id="element-56" />
                    <span data-id="element-57">
                      {t.location} | {t.role}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}